import React from 'react'
import { CircleFlag } from 'react-circle-flags'

export const SerbianFlag = () => <CircleFlag countryCode="rs"  />
export const EnglishFlag = () => <CircleFlag countryCode="uk"  />
export const RussianFlag = () => <CircleFlag countryCode="ru"  />
